<template>
    <div class="container h-100" v-loading="loading">
        <div class="d-flex justify-content-center align-items-center h-100">
            <div class="base-screen">
                <b-card class="form-screen">
                    <div class="text-center">
                        <img src="../assets/styles/img/logo-large.png" alt="Image placeholder" class="logo-img" />
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="width-wrap otp-screen">
                                <b-form-group>
                                    <!--<label
                                      class="label-control d-block text-center mb-3"
                                      for="email"
                                    >{{lang.label.enterOtp}}</label>-->
                                    <b-card-group deck>
                                        <b-card>
                                            <b-card-text>
                                                <b-form-input @input="onInputEvent(1, $event)"
                                                               @keyup="onKeyUpEvent(1, $event)"
                                                               @keypress="isNumber(1,$event)"
                                                               class="digit-group" ref="inp1" id="inp1" v-model="inp1" type="tel" autocomplete="off" maxlength="1"></b-form-input>
                                            </b-card-text>
                                        </b-card>
                                        <b-card>
                                            <b-card-text>
                                                <b-form-input @input="onInputEvent(2, $event)"
                                                               @keyup="onKeyUpEvent(2, $event)"
                                                               @keypress="isNumber(2,$event)"
                                                               class="digit-group" ref="inp2" id="inp2" v-model="inp2" type="tel" autocomplete="off" maxlength="1"></b-form-input>
                                            </b-card-text>
                                        </b-card>
                                        <b-card>
                                            <b-card-text>
                                                <b-form-input @input="onInputEvent(3, $event)"
                                                               @keyup="onKeyUpEvent(3, $event)"
                                                               @keypress="isNumber(3,$event)"
                                                               class="digit-group" ref="inp3" id="inp3" v-model="inp3" type="tel" autocomplete="off" maxlength="1"></b-form-input>
                                            </b-card-text>
                                        </b-card>
                                        <b-card>
                                            <b-card-text>
                                                <b-form-input
                                                    @input="onInputEvent(4, $event)"
                                                    @keyup="onKeyUpEvent(4, $event)"
                                                    @keypress="isNumber(4,$event)"
                                                    class="digit-group" ref="inp4" id="inp4" v-model="inp4" type="tel" autocomplete="off" maxlength="1"></b-form-input>
                                            </b-card-text>
                                        </b-card>
                                    </b-card-group>
                                </b-form-group>
                                <div class="resend-time">
                                    <a href="javascript:void(0)" class="text-underline" :class="timeLeft < 1? '' : 'otp-disable'" @click="reSendOTP">{{lang.label.resendOtp}}</a>
                                    <label class="float-right">{{timer}}</label><br>
                                    <span  v-if="otpError && !OtpExpired" class="error">{{lang.label.enterOtpError}}</span>
                                    <span  v-else-if="OtpExpired" class="error">{{lang.label.OtpExpired}}</span>
                                    <span  v-else-if="wrongOTP" class="error">{{lang.label.wrongOTP}}</span>
                                </div>
                            </div>
                            <b-form-group class="mb-0 btn-mt">
                                <b-btn
                                    type="submit"
                                    variant="primary"
                                    class="w-100"
                                    @click="homePage()"
                                    >{{lang.label.buttons.verifyOtp}}</b-btn>
                            </b-form-group>
                        </div>
                    </div>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery';
    import Vue from 'vue';
    import VueSweetalert2 from 'vue-sweetalert2';
    import {mapGetters} from "vuex";
    import state from "../store/state";
    Vue.use(VueSweetalert2);
    const uuidv4 = require("uuid");

    export default {
        components: {},
        computed: {
            ...mapGetters({
                    login: "login",
                    loading: "loading",
                    getTimeForOtp: "getTimeForOtp",
                    fcmToken: "fcmToken",
            })
        },
        data() {
            return {
                timeOut: true,
                otpError: false,
                OtpExpired: false,
                wrongOTP: false,
                inputs: {
                    inp1: false,
                    inp2: false,
                    inp3: false,
                    inp4: false,
                },
                timeOutFlag: false,
                numerals: [1, 2, 3, 4, 5, 6, 7, 8, 9, 0],
                alertFlag: true,
                timer: '',
                timeLeft: '',
                lang: this.$lang.otp,
                inp1: "",
                inp2: "",
                inp3: "",
                inp4: "",
                mobileNumber: null,
                // fcmToken: null,
                otp: null,
            };
        },
        watch: {
            inp1: function (val) {
                if (val) {
                    this.otpError = false;
                    this.OtpExpired = false;
                }
            },
            inp2: function (val) {
                if (val) {
                    this.otpError = false;
                    this.OtpExpired = false;
                }
            },
            inp3: function (val) {
                if (val) {
                    this.otpError = false;
                    this.OtpExpired = false;
                }
            },
            inp4: function (val) {
                if (val) {
                    this.otpError = false;
                    this.OtpExpired = false;
                }
            },
            timeLeft: function (val) {
                if (val == 0) {
                    this.timeOut = true;
                    this.timeOutFlag = true;
                } else {
                    this.timeOut = false;
                }
            }
        },
        mounted() {
            let self = this;
            self.timeLeft = this.getTimeForOtp ? this.getTimeForOtp : state.timeLeft;
            this.mobileNumber = localStorage.getItem('mobile_number');
            this.otp = JSON.parse(localStorage.getItem('password'));
            this.displayTimer();
            $("#inp1").focus();
            $('.digit-group').find('input').each(function () {
                $(this).attr('maxlength', 1);
                $(this).on('keyup', function (e) {
                    var parent = $($(this).parent());
                    if (e.keyCode === 8 || e.keyCode === 37) {
                        var prev = parent.find('input#' + $(this).data('previous'));

                        if (prev.length) {
                            $(prev).select();
                        }
                    } else if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode === 39) {
                        var next = parent.find('input#' + $(this).data('next'));

                        if (next.length) {
                            $(next).select();
                        } else {
                            if (parent.data('autosubmit')) {
                                parent.submit();
                            }
                        }
                    }
                });
            });
        },
        methods: {
            isNumber: function (index, evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    if (this.$refs['inp' + index].value && index != 4) {
                        this.$refs['inp' + (index + 1)].focus();
                    } else {
                    }
                    return true;
                }
            },
            displayTimer() {
                let self = this;
                let timer = setInterval(function () {
                    if (self.timeLeft == -1) {
                        self.timeOut = true;
                        if (self.alertFlag) {
                            localStorage.setItem('password', null);
                        }
                        clearInterval(timer);
                    } else {
                        self.timer = self.secondsToMS(self.timeLeft);
                        self.timeLeft--;
                    }
                }, 1000);
            },
            secondsToMS(d) {
                d = Number(d);
                var m = Math.floor(d % 3600 / 60);
                var s = Math.floor(d % 3600 % 60);
                let min = m > 9 ? m : "0" + m;
                let sec = s > 9 ? s : "0" + s;
                return min + ":" + sec
            },
            onInputEvent(index, e) {
                if (!this.numerals.includes(parseInt(e))) {
                    this.inputs["inp" + index] = true;
                } else {
                    this.inputs["inp" + index] = false;
                }
                let self = this;
                if (this.numerals.includes(parseInt(e))) {
                    if (index < 4 && this.getCodeBoxElement(index).value.length) {
                        this.getCodeBoxElement(index + 1).focus();
                    }
                } else {
                    if (index == 1) {
                        self.inp1 = '';
                    } else if (index == 2) {
                        self.inp2 = '';
                    } else if (index == 3) {
                        self.inp3 = '';
                    } else {
                        self.inp4 = '';
                    }
                }
            },
            onKeyUpEvent(index, event) {
                if (event.code == "Backspace" && !this.getCodeBoxElement(index).value.length && index != 1) {
                    this.getCodeBoxElement(index - 1).focus();
                }
            },
            getCodeBoxElement(index) {
                return document.getElementById('inp' + index);
            },
            getImgUrl(pic) {
                return require("../assets/styles/img/" + pic);
            },
            getValidationState( { dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },
            homePage() {
                if (this.inp1 + this.inp2 + this.inp3 + this.inp4 == '') {
                    this.otpError = true;
                    return true;
                }
                let self = this;
                let otp = localStorage.getItem('password');
                let userOtp = this.inp1 + this.inp2 + this.inp3 + this.inp4;
                if (otp == userOtp) {
                    this.timeOut = false;
                    this.alertFlag = false;
                    let deviceId = uuidv4.v4();
                    this.$store.commit('setDeviceId', deviceId);
                    let loginData = {
                        "mobile": this.mobileNumber,
                        "otp": this.otp,
                        "deviceId": deviceId,
                        "deviceType": 3,
                        // "deviceToken":"abc"
                        "deviceToken": self.fcmToken
                    };
                    this.$store.dispatch('login', loginData).then(response => {
                        console.log(response)
                        if (response.data.token) {
                            response.data.deviceId = deviceId;
                            this.$store.commit("setLogin", response.data);
                            this.$store.commit("setNotificationStatus", response.data.notificationStatus);
                            this.$router.push({name: 'home'});
                        } else {
                            this.$swal.fire({
                                title: 'Something Went Wrong',
                                text: 'Please try again',
                                type: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                self.timeLeft = self.getTimeForOtp ? self.getTimeForOtp : state.timeLeft;
                                self.timeOut = false;
                            });
                        }
                    });
                } else {
                    // let userOtp = this.inp1+this.inp2+this.inp3+this.inp4;
                    if (this.timeLeft <= 0) {
                        // this.inp1 = this.inp2 = this.inp3 = this.inp4 = '';
                        this.OtpExpired = true;
                    } else {
                        this.wrongOTP = true;
                    }
                    // self.otpError = true;
                    /*this.$swal.fire({
                     text: this.lang.label.wrongOtp,
                     type: 'warning',
                     showCancelButton: true,
                     confirmButtonColor: '#3085d6',
                     cancelButtonColor: '#d33',
                     confirmButtonText: 'OK'
                     }).then((result) => {
                     })*/
                }
            },
            reSendOTP() {
                this.timeLeft = this.getTimeForOtp ? this.getTimeForOtp : state.timeLeft;
                this.otpError = false;
                this.OtpExpired = false;
                this.wrongOTP = false;
                this.timeOut = false;
                this.timeOutFlag = true;
                this.displayTimer();
                this.$store.dispatch('sendOtp', {"mobile": this.mobileNumber}).then(response => {
                    this.inp1 = this.inp2 = this.inp3 = this.inp4 = '';
                    localStorage.setItem('password', response.data.otp);
                    $("#inp1").focus();
                })
            }
        },
        destroyed() {
            localStorage.setItem('password', null);
            this.alertFlag = false;
        }
    };
</script>
